import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { ClipboardIconState } from "./clipboard-icon";

@Component({
    standalone: true,
    selector: 'gene-clipboard-icon',
    templateUrl: './clipboard-icon.component.html',
    styleUrls: ['./clipboard-icon.component.css']
})
export class ClipboardIconComponent {
    @Input() width!: string;
    @Input() height!: string;
    @Input() color!: string;

    state: ClipboardIconState = 'copy';

    constructor(
        private cdr: ChangeDetectorRef,
    ) { }

    toggleState(): void {
        this.state = this.state === 'copy' ? 'check' : 'copy';
        setTimeout(() => {
            this.state = 'copy';
            this.cdr.detectChanges();
        }, 2000);
    };
};